export default __webpack_public_path__ + "static/media/page-break.8c2f642e.svg";